import './kitStyles';
import React from 'react';
import { Typography } from 'antd';
import { pickStrings } from '@/i18n';
import { kitStrings } from '@/i18n/dictionaries/kit';
import { kitDsStrings } from '@/i18n/dictionaries/kitDs';
import { Empty } from './Empty';

/**
 * WEB-4003 юнит 1 — пустое состояние antd для всего кабинета: подмена
 * `renderEmpty` корневого `ConfigProvider` (`App.tsx`) и панелей фильтров
 * (`renderFilterEmpty` — та же функция). Таблицы, списки, перенос и всё без
 * имени — общее пустое состояние кита с картинкой сервиса и текстом «Нет
 * данных» (тот же текст, что показывала заглушка Ant). Выпадашки — короткая
 * строка «Нет вариантов» без значка (WEB-665, как прежний `renderFilterEmpty`):
 * картинка в списке вариантов не к месту; разметка строки прежняя.
 * Таблицы со своим `locale.emptyText` эту подмену не зовут.
 */
const PICKERS = new Set([
  'Select',
  'Cascader',
  'TreeSelect',
  'AutoComplete',
  'Mentions',
]);

export function renderKitEmpty(componentName?: string): React.ReactNode {
  if (componentName && PICKERS.has(componentName)) {
    return (
      <div style={{ padding: '10px 0', textAlign: 'center' }}>
        <Typography.Text type="secondary" style={{ fontSize: 13 }}>
          {pickStrings(kitStrings).noOptions}
        </Typography.Text>
      </div>
    );
  }
  return <Empty title={pickStrings(kitDsStrings).emptyNoData} />;
}
